export default __webpack_public_path__ + "static/afterglow-fc3d6169944a6a8ae8c18d239047ffc1.webp";